<app-loading-spinner
  *ngIf="loadingSpinnerService.loading$ | async"></app-loading-spinner>
<div class="tab-content">
  <div class="header">
    <div class="header-left">
      <!-- Tab buttons to switch between active and inactive cards -->
      <button 
        class="hover-button"
        [class.active]="isActiveTab"
        (click)="setActiveTab(true)">
        Active
      </button>
      <button 
        class="hover-button"
        [class.active]="!isActiveTab"
        (click)="setActiveTab(false)">
        Inactive
      </button>
    </div>

    <button
      class="hover-button"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#giftExpand"
      aria-expanded="false"
      aria-controls="giftExpand">
      + Create new voucher
    </button>
  </div>

  <!-- Show empty state if there are no vouchers in the current tab -->
  <div class="empty-vouchers" *ngIf="getFilteredGiftCards('birthday').length === 0 && getFilteredGiftCards('game').length === 0 && getFilteredGiftCards('other').length === 0">
    <img src="../../assets/images/empty-vouchers.svg" alt="" />
    <h2>There's no active Vouchers, yet</h2>
    <p>
      Managing your vouchers is super simple, so, why 
      don't you start creating now?
    </p>
    <button class="hover-button"  data-bs-toggle="collapse"
    data-bs-target="#giftExpand"
    aria-expanded="false"
    aria-controls="giftExpand">+ Create new voucher</button>
  </div>

  <!-- Birthday Vouchers Section -->
  <div *ngIf="getFilteredGiftCards('birthday').length > 0">
    <h2 class="category-title">Birthday Vouchers</h2>
    <div class="row">
      <ng-container *ngFor="let card of getFilteredGiftCards('birthday')">
        <div class="col-md-4 col-sm-6">
          <app-gift-card (openEditForm)="expandFormWithCardData($event)" (giftCardUpdated)="onGiftCardUpdated()" (newTab)="checkTabStatus($event)"  [card]="card"></app-gift-card>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Extra Game Vouchers Section -->
  <div *ngIf="getFilteredGiftCards('game').length > 0">
    <h2 class="category-title">Extra Game Vouchers</h2>
    <div class="row">
      <ng-container *ngFor="let card of getFilteredGiftCards('game')">
        <div class="col-md-4 col-sm-6">
          <app-gift-card (giftCardUpdated)="onGiftCardUpdated()" (openEditForm)="expandFormWithCardData($event)" (newTab)="checkTabStatus($event)" [card]="card"></app-gift-card>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Other Vouchers Section -->
  <div *ngIf="getFilteredGiftCards('other').length > 0">
    <h2 class="category-title">Other Vouchers</h2>
    <div class="row">
      <ng-container *ngFor="let card of getFilteredGiftCards('other')">
        <div class="col-md-4 col-sm-6">
          <app-gift-card (giftCardUpdated)="onGiftCardUpdated()" (openEditForm)="expandFormWithCardData($event)" (newTab)="checkTabStatus($event)" [card]="card"></app-gift-card>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- Create vaucer form -->

<div
  class="collapse collapse-horizontal new-gift-card"
  id="giftExpand"
  #giftExpand
  (shown.bs.collapse)="toggleBackdrop(true)"
  (hidden.bs.collapse)="toggleBackdrop(false)"
>
  <div class="new-gift-card-top">
    <h3>New voucher</h3>
    <div class="d-flex align-items-center">
      <button data-bs-toggle="collapse" data-bs-target="#giftExpand">
        <img src="../../assets/images/close-notification.svg" alt="" />
      </button>
    </div>
  </div>

  <div class="new-gift-card-bottom">
    <form [formGroup]="giftCardForm" class="d-flex flex-column justify-content-between h-100">
      <div>
        <div class="mb-3 input-wrapper">
          <label for="giftCardTitle" class="form-label">
            <span style="color: rgba(255, 153, 0, 1)">*</span> Title
          </label>
          <input
            type="text"
            class="form-control"
            id="giftCardTitle"
            placeholder="ex. Special Occasions, Extraordinary Celebrations!"
            formControlName="giftCardTitle"
            maxlength="30"
          />
  
          <div
            *ngIf="giftCardTitle.invalid && giftCardTitle.touched"
            class="text-danger"
          ></div>
  
          <span
            class="text-limit"
            [ngClass]="{ 'max-characters': giftCardTitle.value?.length === 30 }"
            >max 30</span
          >
        </div>
  
        <div class="mb-3 input-wrapper">
          <label for="giftCardDetails" class="form-label">
            <span style="color: rgba(255, 153, 0, 1)">*</span> Voucher details
          </label>
          <textarea
            class="form-control"
            id="giftCardDetails"
            rows="3"
            placeholder="Short description"
            formControlName="giftCardDetails"
            maxlength="140"
          ></textarea>
  
          <div
            *ngIf="giftCardDetails.invalid && giftCardDetails.touched"
            class="text-danger"
          ></div>
  
          <span
            class="text-limit"
            [ngClass]="{
              'max-characters': giftCardDetails.value?.length === 140
            }"
            >max 140</span
          >
        </div>
  
        <div class="mb-3 input-wrapper">
          <label class="form-label">
            <span style="color: rgba(255, 153, 0, 1)">*</span> Type
          </label>
          <select
            id="giftCardType"
            formControlName="giftCardType"
            class="form-select"
            aria-label="Default select example"
          >
            <option value="birthday">Birthday</option>
            <option value="game">Extra game</option>
            <option value="other">Other</option>
          </select>
  
          <div
            *ngIf="giftCardDetails.invalid && giftCardDetails.touched"
            class="text-danger"
          ></div>
        </div>
        <div class="mb-3 input-wrapper">
          <label class="form-label">
            <span style="color: rgba(255, 153, 0, 1)">*</span> Add image
          </label>
          <div class="add-image text-center">
            <img src="../../../assets/images/media.svg" alt="" />
            <h3>Image</h3>
            <p>
              When uploading a 2:1 image, ensure it adjusts smoothly to different
              <br />
              screen sizes and is optimized for faster loading.
            </p>
            <label for="mediaGift" [ngStyle]="{'border-color' : mediaUploaded ? 'rgba(147, 147, 147, 1)' : 'rgba(0, 131, 172, 1)',
              'color': mediaUploaded ? 'rgba(147, 147, 147, 1)' : 'rgba(0, 131, 172, 1)'
            }" class="add-image-label hover-button">
              + Add image
            </label>
            <br />
            <input
              [disabled]="mediaUploaded"
              type="file"
              style="visibility: hidden; height: 0"
              id="mediaGift"
              accept="image/png, image/gif, image/jpeg"
              (change)="onMediaChange($event)"
            />
          </div>
        </div>
  
        <div class="selected-media" *ngIf="selectedMedia.length > 0">
          <ul>
            <li
              *ngFor="let file of selectedMedia; let i = index"
              [ngClass]="{ 'invalid-file': file.invalid }"
            >
              <div class="selected-info">
                <img
                  *ngIf="file.thumbnail"
                  [src]="file.thumbnail"
                  alt="Selected media"
                />
                <img
                  *ngIf="!file.thumbnail && file.invalid"
                  src="../../../assets/images/not-supported-file.svg"
                  alt="Selected media"
                />
                <div>
                  <p>
                    {{ file.name }}
                  </p>
                  <small *ngIf="!file.invalid && file.size !== 0">
                    {{ (file.size / (1024 * 1024)).toFixed(2) }} MB
                  </small>
                  <small *ngIf="file.invalid"> {{ file.errorMessage }} </small>
                </div>
              </div>
              <button
                class="border-0 bg-transparent hover-button"
                (click)="removeFile(i)"
              >
                <img src="../../../assets/images/TrashSimple.svg" alt="Delete" />
              </button>
            </li>
          </ul>
        </div>
  
        <div class="mb-3 input-wrapper">
          <label for="giftExpirationDate" class="form-label"
            >Expire date
            <span class="fw-normal" style="color: rgba(147, 147, 147, 1)"
              >(optional)</span
            >
          </label>
          <input
            type="date"
            formControlName="giftExpirationDate"
            id="giftExpirationDate"
            class="form-control"
          />
        </div>
        <div class="mb-3 input-wrapper">
          <label for="giftActivationCode"  class="form-label"
            >Activation code
          </label>
          <input
            type="text"
            formControlName="giftActivationCode"
            id="giftActivationCode"
            class="form-control"
            placeholder="Enter activation code"
          />
        </div>
      </div>
      <div class="submit-wrapper">
        <button
          type="submit"
          class="submit-btn hover-button"
          [disabled]="!giftCardForm.valid"
          (click)="onAddGiftCard(editMode, selectedCard)"
        >
          Send
        </button>
        <button
          type="button"
          class="cancel-btn"
          (click)="clearForm()"
          data-bs-toggle="collapse"
          data-bs-target="#giftExpand"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>

<div
  class="sidebar-backdrop"
  data-bs-toggle="collapse"
  data-bs-target="#giftExpand"
  #backdrop
></div>
